var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5769 14.1613H18C18 14.3857 17.9086 14.6013 17.7434 14.7602C17.414 15.0765 16.8873 15.0803 16.5526 14.7691L12.4998 10.9961L8.44708 14.7691C8.11288 15.0803 7.58595 15.0766 7.25627 14.76C6.91074 14.4276 6.91526 13.8804 7.26594 13.5538L11.9097 9.23046C12.2403 8.92314 12.7594 8.92314 13.0902 9.23069L17.7335 13.5536C17.9046 13.7127 18 13.9323 18 14.1613H17.5769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.1c3927eebb45e4c67157f021e0f838fd.svg";
export { ForwardRef as ReactComponent };